import React from 'react';
import '../App.css'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Carousel from 'react-bootstrap/Carousel'

// class Carousel extends React.Component {

function CarouselModal(props) {
        //const s3_url = "https://mickey-fisher-pics.s3.us-west-1.amazonaws.com/"
        const s3_url = "https://d136r6umb0zhdt.cloudfront.net/"
      


      return ( 
        <>
        <Modal size='xl' show={props.show} onHide={props.handle_close_carousel} centered>
            <Modal.Header style={{backgroundColor: "#f0ecec", borderBottom:"1px solid #acb3c1", display: "flex", justifyContent: "center",textAlign: "center", alignItems: "center",}} closeButton>
            {props.no_pics ? 
                <Modal.Title>No pictures from {props.city}. Check out these pics from my trip to Georgia (the country!)</Modal.Title> 
                : 
                <Modal.Title className="modal-title-center">{props.city}</Modal.Title>
            }
            
            </Modal.Header>
            <Modal.Body style={{backgroundColor: "#f0ecec", borderBottom:"1px solid #acb3c1"}}>

            <Carousel variant="dark">
                {props.images.map((value, index) => {
                    return (
                    <Carousel.Item key={`${value}_${index}`}>
                        <img
                        className="d-block img-fluid"
                        src={s3_url+value}
                        alt={index}
                        />
                        <Carousel.Caption>
                        </Carousel.Caption>
                    </Carousel.Item>
                    )
                })}
                
            </Carousel>

            </Modal.Body>
            <Modal.Footer style={{backgroundColor: "#f0ecec"}}>
            <Button variant="secondary" onClick={props.handle_close_carousel}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>
        </>
      )
}

export default CarouselModal;